import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { Suspense } from 'react';
import './App.css';
import { AuthenticatedUser } from './AuthenticatedUser';
import { createClient } from './lib/azure_ad';
import { LoginPage } from './views/LoginPage';
import { theme } from './theme/theme';
import { Helmet } from 'react-helmet';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ThemeProvider } from '@mui/material';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PublicDriverPage from './views/PublicDriverPage';
import { IdleTimeoutProvider } from './components/pageIdle/IdleTimeoutContext';
import SessionTimeoutModal from './components/pageIdle/SessionTimeoutModal';

export function App() {
  const pca = createClient();
  const IDLE_TIMEOUT = 1000 * 60 * 60; // 60min
  const TIME_TO_PROMPT_BEFORE_TIMEOUT = 1000 * 60; // 1min
  const EXTEND_TIME = 1000 * 60 * 5; // 5min
  return (
    <Suspense fallback="loading">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider theme={theme}>
          <div className="App">
            <Helmet titleTemplate="%s - Nexus" defaultTitle="Nexus">
              <meta name="description" content="Nexus applications" />
            </Helmet>
            <Router>
              <Switch>
                <Route path="/driver/:token">
                  <PublicDriverPage />
                </Route>

                <Route>
                  <MsalProvider instance={pca}>
                    <AuthenticatedTemplate>
                      <IdleTimeoutProvider
                        timeout={IDLE_TIMEOUT}
                        timeToPromptBeforeTimeout={
                          TIME_TO_PROMPT_BEFORE_TIMEOUT
                        }
                        extendTime={EXTEND_TIME}
                      >
                        {/* The modal can be placed here to be available globally */}
                        <SessionTimeoutModal />
                        <AuthenticatedUser />
                      </IdleTimeoutProvider>
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                      <LoginPage />
                    </UnauthenticatedTemplate>
                  </MsalProvider>
                </Route>
              </Switch>
            </Router>
          </div>
        </ThemeProvider>
      </LocalizationProvider>
    </Suspense>
  );
}
